// extracted by mini-css-extract-plugin
export default {"Card":"webpack-components-core-Card-Card-module__Card"};